module.exports = __webpack_public_path__ + "static/media/report2021.9348819b.pdf";